import script from "./ActionButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionButtons.vue?vue&type=script&setup=true&lang=js"

import "./ActionButtons.vue?vue&type=style&index=0&id=73df66b1&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73df66b1"]])

export default __exports__